import { getLocale } from "../runtime";

const sv_nlcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Netherlands`
};

const nlcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nlcountryenglish(inputs)
	return "nlCountryEnglish";
};

export { nlcountryenglish as "nlCountryEnglish" };